import { render, staticRenderFns } from "./GroupMemberSelector.vue?vue&type=template&id=968a283e"
import script from "./GroupMemberSelector.vue?vue&type=script&lang=js"
export * from "./GroupMemberSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberSelector.vue?vue&type=style&index=0&id=968a283e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports